export enum WorkPlace {
CompanyDepartment,
Other,
}
